// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__ErrorPage from "../../../../pages/ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../../../models/Kkm.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(kkm) {
  return function (maximizeShift) {
    return function (onMaximize) {
      return function (orgId) {
        return function (idOpt) {
          const id = idOpt !== undefined ? idOpt : "";
          return function (onCloseOpt) {
            const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
                  
                });
            const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
            const deviceType = state.deviceType;
            const match = Buhta_core__Tenant.useTenant(undefined);
            const tenant = match[0];
            const contextRoute = function (route) {
              return Buhta_cabinet__Route.contextRoute(tenant.ctx, orgId, route);
            };
            const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
            let shiftId;
            if (typeof currentRoute === "number") {
              shiftId = id;
            } else {
              switch (currentRoute.TAG | 0) {
                case /* Org */6 :
                    const match$1 = currentRoute._1;
                    if (typeof match$1 === "number" || match$1.TAG !== /* Kassa */2) {
                      shiftId = id;
                    } else {
                      const match$2 = match$1._0._0;
                      if (typeof match$2 === "number") {
                        shiftId = id;
                      } else {
                        const match$3 = match$2._1;
                        if (typeof match$3 === "number" || match$3.TAG !== /* Journal */2) {
                          shiftId = id;
                        } else {
                          const match$4 = match$3._0;
                          if (typeof match$4 === "number") {
                            shiftId = id;
                          } else {
                            const shiftid = match$4._0;
                            shiftId = typeof shiftid === "number" || shiftid.TAG !== /* View */0 ? id : shiftid._0;
                          }
                        }
                      }
                    }
                    break;
                case /* Admin */7 :
                    const match$5 = currentRoute._0;
                    if (typeof match$5 === "number" || match$5.TAG !== /* Orgs */1) {
                      shiftId = id;
                    } else {
                      const match$6 = match$5._0;
                      if (typeof match$6 === "number") {
                        shiftId = id;
                      } else {
                        const match$7 = match$6._1;
                        if (typeof match$7 === "number" || match$7.TAG !== /* Kassa */2) {
                          shiftId = id;
                        } else {
                          const match$8 = match$7._0._0;
                          if (typeof match$8 === "number") {
                            shiftId = id;
                          } else {
                            const match$9 = match$8._1;
                            if (typeof match$9 === "number" || match$9.TAG !== /* Journal */2) {
                              shiftId = id;
                            } else {
                              const match$10 = match$9._0;
                              if (typeof match$10 === "number") {
                                shiftId = id;
                              } else {
                                const shiftid$1 = match$10._0;
                                shiftId = typeof shiftid$1 === "number" || shiftid$1.TAG !== /* View */0 ? id : shiftid$1._0;
                              }
                            }
                          }
                        }
                      }
                    }
                    break;
                default:
                  shiftId = id;
              }
            }
            const func = Buhta_cabinet__Kassa.ZxReportService.view;
            const match$11 = Buhta_core__GrpcState.useModel((function (param) {
                    return Curry._4(func, param, kkm, /* [] */0, shiftId);
                  }), undefined);
            const dispatch = match$11[1];
            const shiftData = match$11[0];
            React.useEffect((function () {
                    Curry._2(dispatch, undefined, undefined);
                  }), [
                  kkm,
                  shiftId
                ]);
            let tmp;
            if (typeof shiftData === "string") {
              tmp = shiftData === "Loading" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
            } else if (shiftData.NAME === "Data") {
              const shift = shiftData.VAL;
              const o = shift.org;
              const org = o !== undefined ? o : ({
                    id: 0,
                    name: "",
                    "type'": /* ORG_TYPE_UNSPECIFIED */0,
                    tin: "",
                    address: "",
                    vat_cert_series: "",
                    vat_cert_number: ""
                  });
              const k = shift.kkm;
              const kkmObj = k !== undefined ? k : ({
                    serial_num: "",
                    ofd_provider_id: 0,
                    ofd_register_num: "",
                    address_street: "",
                    address_street1: "",
                    address_street2: ""
                  });
              const reportTime = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(shift.report_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
              tmp = JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      deviceType === "mobile" ? null : JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        id === "" ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                                route: contextRoute({
                                                      TAG: /* Kassa */2,
                                                      _0: /* Kkms */{
                                                        _0: /* Kkm */{
                                                          _0: kkm,
                                                          _1: {
                                                            TAG: /* Journal */2,
                                                            _0: /* Shifts */{
                                                              _0: /* List */0
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }),
                                                children: JsxRuntime.jsx("img", {
                                                      className: "w-5 h-5",
                                                      src: StaticAsset.src("/static/icons/close-20.svg")
                                                    })
                                              }) : JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx("img", {
                                                      className: "w-5 h-5",
                                                      src: StaticAsset.src("/static/icons/close-20.svg")
                                                    }),
                                                onClick: (function (param) {
                                                    Curry._1(onClose, undefined);
                                                  })
                                              }),
                                        JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                              className: "ml-4",
                                              children: "Отчет №" + String(shift.serial_id)
                                            })
                                      ],
                                      className: "flex items-center"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("button", {
                                            children: maximizeShift ? JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    src: StaticAsset.src("/static/icons/minimize.svg")
                                                  }) : JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    src: StaticAsset.src("/static/icons/maximize.svg")
                                                  }),
                                            onClick: (function (param) {
                                                Curry._1(onMaximize, !maximizeShift);
                                              })
                                          }),
                                      className: "flex items-center"
                                    })
                              ],
                              className: "py-4 px-6 flex items-center justify-between border-b border-gray-main"
                            }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          children: org.name
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "text-gray-medium",
                                          children: "БИН: " + org.tin
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "text-gray-medium",
                                          children: "ЗНК: " + kkmObj.serial_num
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "text-gray-medium",
                                          children: "РНК: " + kkmObj.ofd_register_num
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "mt-3 text-gray-medium",
                                          children: "Время: " + reportTime
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "text-gray-medium",
                                          children: "Смена №" + String(shift.shift_id)
                                        }),
                                    JsxRuntime.jsx("hr", {
                                          className: "mt-4"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "mt-4 text-default-gray",
                                          children: "Чеки"
                                        }),
                                    Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, receipt_result) {
                                                const Key = String(i);
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            children: Buhta_cabinet__Kkm.OperationType.toStringPlural(receipt_result.operation_type)
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            children: MelNumeral.format({
                                                                                  NAME: "Str",
                                                                                  VAL: receipt_result.amount
                                                                                }) + " ₸"
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between mt-2"
                                                                  }),
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: "За смену"
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: MelNumeral.formatInt({
                                                                                  NAME: "Int",
                                                                                  VAL: receipt_result.count
                                                                                })
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between"
                                                                  }),
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: "Всего"
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: MelNumeral.formatInt({
                                                                                  NAME: "Int",
                                                                                  VAL: receipt_result.count_total
                                                                                })
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between"
                                                                  })
                                                            ]
                                                          }, Key);
                                              }), shift.receipt_results)),
                                    JsxRuntime.jsx("hr", {
                                          className: "mt-4"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "mt-4 text-default-gray",
                                          children: "Наличные"
                                        }),
                                    Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, mp_result) {
                                                const Key = String(i);
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            children: Buhta_cabinet__Kkm.MoneyPlacementType.toStringShort(mp_result.placement_type)
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            children: MelNumeral.format({
                                                                                  NAME: "Str",
                                                                                  VAL: mp_result.amount
                                                                                }) + " ₸"
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between mt-2"
                                                                  }),
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: "За смену"
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: MelNumeral.formatInt({
                                                                                  NAME: "Int",
                                                                                  VAL: mp_result.count
                                                                                })
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between"
                                                                  }),
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: "Всего"
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: MelNumeral.formatInt({
                                                                                  NAME: "Int",
                                                                                  VAL: mp_result.count_total
                                                                                })
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between"
                                                                  })
                                                            ]
                                                          }, Key);
                                              }), shift.money_placement_results)),
                                    JsxRuntime.jsx("hr", {
                                          className: "mt-4"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "mt-4 mb-2 text-default-gray",
                                          children: "Необнуляемая сумма на начало смены"
                                        }),
                                    Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, balance) {
                                                const Key = String(i);
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                    children: Buhta_cabinet__Kkm.OperationType.toStringPlural(balance.operation_type)
                                                                  }),
                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                    children: MelNumeral.format({
                                                                          NAME: "Str",
                                                                          VAL: balance.amount
                                                                        }) + " ₸"
                                                                  })
                                                            ],
                                                            className: "flex justify-between"
                                                          }, Key);
                                              }), shift.opening_balances)),
                                    JsxRuntime.jsx("hr", {
                                          className: "mt-4"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "mt-4 text-default-gray",
                                          children: "Сменный итог"
                                        }),
                                    Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, shift_result) {
                                                const Key = String(i);
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            children: Buhta_cabinet__Kkm.OperationType.toStringPlural(shift_result.operation_type)
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            children: MelNumeral.format({
                                                                                  NAME: "Str",
                                                                                  VAL: shift_result.amount
                                                                                }) + " ₸"
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between mt-2"
                                                                  }),
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: "Количество"
                                                                          }),
                                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                            className: "text-gray-medium",
                                                                            children: MelNumeral.formatInt({
                                                                                  NAME: "Int",
                                                                                  VAL: shift_result.count
                                                                                })
                                                                          })
                                                                    ],
                                                                    className: "flex justify-between"
                                                                  })
                                                            ]
                                                          }, Key);
                                              }), shift.shift_results)),
                                    JsxRuntime.jsx("hr", {
                                          className: "mt-4"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "mt-4 mb-2 text-default-gray",
                                          children: "Необнуляемый итог"
                                        }),
                                    Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, balance) {
                                                const Key = String(i);
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                    children: Buhta_cabinet__Kkm.OperationType.toStringPlural(balance.operation_type)
                                                                  }),
                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                    children: MelNumeral.format({
                                                                          NAME: "Str",
                                                                          VAL: balance.amount
                                                                        }) + " ₸"
                                                                  })
                                                            ],
                                                            className: "flex justify-between"
                                                          }, Key);
                                              }), shift.closing_balances)),
                                    JsxRuntime.jsx("hr", {
                                          className: "mt-4"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "mt-4 text-gray-medium",
                                          children: "Оператор фискальных данных: " + Buhta_cabinet__Kkm.Provider.toString(kkmObj.ofd_provider_id)
                                        })
                                  ],
                                  className: Cn.on("lg:w-122", maximizeShift)
                                }),
                            className: Cn.$plus("px-4 lg:px-6 py-6", Cn.on("flex justify-center", maximizeShift))
                          })
                    ]
                  });
            } else {
              tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
            }
            return JsxRuntime.jsx("div", {
                        children: tmp,
                        className: Cn.$plus(Cn.$plus("lg:border-l border-gray-main shrink-0 flex flex-col overflow-y-auto", Cn.on("w-full lg:w-122", !maximizeShift)), Cn.on("w-full", maximizeShift))
                      });
          };
        };
      };
    };
  };
}

function Shift(Props) {
  return Curry._4(make(Props.kkm)(Props.maximizeShift), Props.onMaximize, Props.orgId, Props.id, Props.onClose);
}

const make$1 = Shift;

export {
  make$1 as make,
}
/* Buhta_cabinet__ErrorPage Not a pure module */
